import type { FC } from 'react';
import { COLOR, Paragraph, getColorClassName } from '@george-labs.com/design-system';

interface Props {
    alias: string;
    'data-cy'?: string;
}

export const ProductAlias: FC<Props> = ({ alias, 'data-cy': dataCy }) => (
    <Paragraph
        className={`${getColorClassName(COLOR.WHITE, {
            foreground: true,
        })} g-h1 g-no-line text-truncate`}
        data-cy={dataCy}
    >
        {alias}
    </Paragraph>
);
